function subpage() {
	const mainSubpage = document.querySelector('main.subpage');
	if (!mainSubpage) return;

	// Subpage code here...


	$('.category-name-wrapper .category-name.has-children').on('click', function (e) {
		if (window.innerWidth >= 768) {
			e.preventDefault();

			$(this).toggleClass('active');
			const $wrapper = $(this).parent();
			$wrapper.next('ul').slideToggle();
		}
	});

	const ERROR_HTML = '\
    <div class="wc-block-components-validation-error fh-vat-error" role="alert">\
      <p id="validate-error-billing_fh/company-vat">\
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="-2 -2 24 24" width="24" height="24" aria-hidden="true" focusable="false">\
          <path d="M10 2c4.42 0 8 3.58 8 8s-3.58 8-8 8-8-3.58-8-8 3.58-8 8-8zm1.13 9.38l.35-6.46H8.52l.35 6.46h2.26zm-.09 3.36c.24-.23.37-.55.37-.96 0-.42-.12-.74-.36-.97s-.59-.35-1.06-.35-.82.12-1.07.35-.37.55-.37.97c0 .41.13.73.38.96.26.23.61.34 1.06.34s.8-.11 1.05-.34z"></path>\
        </svg>\
        <span>Please enter a valid company VAT</span>\
      </p>\
    </div>';

	const vatRegex = /^(?:(?:AT|BE|BG|CY|CZ|DE|DK|EE|EL|ES|FI|FR|GB|HR|HU|IE|IT|LT|LU|LV|MT|NL|PL|PT|RO|SE|SI|SK)U?[0-9A-Z]{2,13}|[0-9]{6}-[0-9]{4})$/i;

	$('.woocommerce-checkout #shipping-fh-company-vat').each(function () {
		const field = $(this);
		const wrapper = field.closest('.wc-block-components-text-input');

		const observer = new MutationObserver(function () {
			wrapper.find('.wc-block-components-validation-error').not('.fh-vat-error').css('display', 'none');
		});

		observer.observe(wrapper[0], { childList: true, subtree: true });

		field.on('blur change input', function () {
			const value = field.val().trim();
			const existingError = wrapper.find('.fh-vat-error');

			if (value === '' || !vatRegex.test(value)) {
				wrapper.addClass('has-error');
				if (existingError.length === 0) {
					wrapper.append(ERROR_HTML);
				}
			} else {
				wrapper.removeClass('has-error');
				existingError.remove();
			}
		});
	});

}
